/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import * as tslib_1 from "tslib";
import { Directive, TemplateRef } from '@angular/core';
import { CdkStepLabel } from '@angular/cdk/stepper';
/**
 * Workaround for https://github.com/angular/angular/issues/17849
 */
export var _MatStepLabel = CdkStepLabel;
var MatStepLabel = (function (_super) {
    tslib_1.__extends(MatStepLabel, _super);
    /**
     * @param {?} template
     */
    function MatStepLabel(template) {
        return _super.call(this, template) || this;
    }
    MatStepLabel.decorators = [
        { type: Directive, args: [{
                    selector: '[matStepLabel]',
                },] },
    ];
    /**
     * @nocollapse
     */
    MatStepLabel.ctorParameters = function () { return [
        { type: TemplateRef, },
    ]; };
    return MatStepLabel;
}(_MatStepLabel));
export { MatStepLabel };
function MatStepLabel_tsickle_Closure_declarations() {
    /** @type {?} */
    MatStepLabel.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatStepLabel.ctorParameters;
}
//# sourceMappingURL=step-label.js.map